<template>
    <v-dialog v-model="$store.state.invoiceKms.kagCostco" min-width="1360px" persistent>
        <v-card>
            <v-toolbar dark color="secondary" dense>
                <v-spacer />
                <v-toolbar-title class="white--text">KAG</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn dark icon left @click="$store.state.invoiceKms.kagCostco = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-row>
                        <v-col cols="2">
                            <v-combobox v-model="InvId
                            " :items="InvIds" :item-value="'index'" :item-text="'index'"
                            auto-select-first dense label="InvId" @change="filtrarOrder(InvId)"></v-combobox>
                        </v-col>
                        <v-col cols="2">
                            <v-combobox v-model="order
                            " :items="orders" :item-value="'index'" :item-text="'index'"
                            auto-select-first dense label="Order" ></v-combobox>
                        </v-col>
                        <v-col cols="1">
                            <v-btn color="red" icon class="my-auto" large @click="report(order)">
                                <v-icon>mdi-file-pdf-box</v-icon> Order
                            </v-btn>
                        </v-col>
                        <v-col>    
                            <v-btn color="secondary" class="my-auto" dark icon @click="printPDFs"><v-icon>mdi-file-multiple</v-icon> Multi-Pdf</v-btn>
                        </v-col>
                        
                    </v-row>
                <v-data-table :headers="headers"  class="my-auto" :items="filteredItems" hide-actions dense>
                            </v-data-table>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props: ['StartDate','EndDate'],
    data: function () {
        return {
            totals: [],
            excel: [],
            alertMsg: '',
            alert: false,
            searchInv: '',
            orders: [],
            InvId:null,
            InvIds: [],
            c:[],
            order: null,
            headers: [
            { text: 'Date', value: 'Date' },
                { text: 'Station', value: 'Station' },
                { text: 'Terminal', value: 'Terminal' },
                { text: 'BillOfLading', value: 'BillOfLading' },
                { text: 'EREG', value: 'EREG' },
                { text: 'PREM', value: 'PREM' },
                { text: 'Diesel', value: 'Diesel' },
                { text: 'MOQ', value: 'MOQ' },
                { text: 'Rate', value: 'GasRate' },
                { text: 'Amount', value: 'Amount' },
                { text: 'FSC', value: 'FSC' },
                { text: 'Split', value: 'Split' },
                { text: 'Demurrage', value: 'Demurrage' },
                { text: 'HST', value: 'HST' },
                { text: 'Total', value: 'Total' },
                { text: 'Order', value: 'Order' },
                { text: 'InvId', value: 'InvId' },
            ],
        };
    },
    async mounted() {
        this.getTransactionKag();
    },
    computed: {
        filteredItems() {
            return this.records.filter(i => {
                return !this.order || i.Order == this.order;
            });
        },
    },
    methods: {
        printPDFs:async function(){
            var str = this.$store;
               str.state.isLoading = true;
               const total = this.orders.length;
            await this.orders.forEach(async (x,idx) => { 
                    var parms = {
                    Order : x,
                    };
                await axios
                    .post('invoice/kga/pdf', parms, {
                        responseType: 'blob',
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        const url = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        var fileName = 'Invoice_'+x+'.pdf';
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', fileName);
                        console.log(this.startDate);
                        document.body.appendChild(link);
                        link.click();
                        str.dispatch('setSnackbar', {
                            color: 'success',
                            text:(idx+1) + '/'+total
                        });
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            });
               str.state.isLoading = false;
        },
        deleteDuplicate: function (arr) {
            const resultado = [];
            for (const elemento of arr) {
                if (!resultado.includes(elemento)) {
                    resultado.push(elemento);
                }
            }
            return resultado;
        },
        filtrarOrder: function(InvId){
            var orders = this.records.filter(x =>{
                return x.InvId === InvId;
            });
            console.log(orders);
            const filterOrd = orders.map(x => {
                return x.Order;
            });
            console.log(filterOrd);
            this.orders = [];
            this.orders = this.deleteDuplicate(filterOrd);
            this.order = this.orders[0];
        },
        getTransactionKag: function () {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
            };
            axios
                .post('invoice/kms/kga', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.records =response.data;
                    var details = response.data;
                    const invIds = details.map(x => {
                        return x.InvId;
                    });
                    this.InvIds = this.deleteDuplicate(invIds);
                    this.InvId = this.InvIds[0];
                    this.filtrarOrder(this.InvId);
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        report: function(order) {
            var parms = {
                Order : order,
            };
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .post('invoice/kga/pdf', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    var fileName = 'Invoice_'+this.order+'.pdf';
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    console.log(this.startDate);
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading  = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading  = false;
                });
        },
    }
};
</script>
